import styled from '@emotion/styled'

import { Image } from '@/components/Image'
import type { MediaProps } from '@/components/Media'
import { BodyM } from '@/components/Typography'
import { CONFIG } from '@/styles/emotion.config'

export interface MediaListItemProps {
  midia: Omit<MediaProps, 'video'>
  description: string
}

const MediaListItemStyles = styled.div({
  /* container */
  '&.mli': {
    display: 'flex',
    alignItems: 'top',
  },

  '&.mli + .mli': {
    marginTop: 'var(--space-3)',
  },

  /* item icon */
  '& .mli--m': {
    width: '3rem',
    height: '3rem',
    marginRight: '1rem',
    borderRadius: '0.625rem',
    flex: '0 0 3.125rem',
  },

  [CONFIG.media.lg]: {
    '&.mli + .mli': {
      marginTop: 'var(--space-4)',
    },
  },
})

export const MediaListItem = ({ midia, description }: MediaListItemProps) => (
  <MediaListItemStyles className="mli">
    {midia && (
      <div className="mli--m">
        <Image data={midia.image} width="48" height="48" layout="fixed" alt="" />
      </div>
    )}
    {description && <BodyM tag="div" dark="medium" html={description} />}
  </MediaListItemStyles>
)
